import React from 'react';

const Sequencer = () => {
    return (
      <React.Fragment>
        <div className="btn__base r3c17">
          <div className="btn">
            <div className="blue__dots">
              <div className="blue__dot"></div>
              <div className="blue__dot"></div>
              <div className="blue__dot"></div>
              <div className="blue__dot"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  export default Sequencer;